module.exports = __webpack_public_path__ + "static/media/vencimientostickets-07-amarillo.5c700d40.svg";